import { render, staticRenderFns } from "./EditSimple.vue?vue&type=template&id=99d3aea6&scoped=true"
import script from "./EditSimple.vue?vue&type=script&lang=js"
export * from "./EditSimple.vue?vue&type=script&lang=js"
import style0 from "./EditSimple.vue?vue&type=style&index=0&id=99d3aea6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99d3aea6",
  null
  
)

export default component.exports